export function MeridianGraphic() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 320 188"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="55"
        y="48"
        width="38"
        height="112"
        rx="2"
        fill="rgba(0,212,200,.15)"
        stroke="rgba(0,212,200,.4)"
        strokeWidth=".5"
      />
      <rect
        x="103"
        y="22"
        width="58"
        height="138"
        rx="2"
        fill="rgba(0,212,200,.2)"
        stroke="rgba(0,212,200,.5)"
        strokeWidth=".5"
      />
      <rect
        x="172"
        y="58"
        width="34"
        height="102"
        rx="2"
        fill="rgba(0,212,200,.12)"
        stroke="rgba(0,212,200,.3)"
        strokeWidth=".5"
      />
      <rect
        x="215"
        y="40"
        width="44"
        height="120"
        rx="2"
        fill="rgba(0,212,200,.18)"
        stroke="rgba(0,212,200,.4)"
        strokeWidth=".5"
      />
      <line x1="0" y1="160" x2="320" y2="160" stroke="rgba(0,212,200,.2)" strokeWidth=".5" />
    </svg>
  );
}

export function GreensGraphic() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 320 188"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="48"
        y="78"
        width="68"
        height="82"
        rx="4"
        fill="rgba(0,180,100,.15)"
        stroke="rgba(0,180,100,.4)"
        strokeWidth=".5"
      />
      <rect
        x="126"
        y="58"
        width="68"
        height="102"
        rx="4"
        fill="rgba(0,180,100,.2)"
        stroke="rgba(0,180,100,.5)"
        strokeWidth=".5"
      />
      <rect
        x="204"
        y="72"
        width="64"
        height="88"
        rx="4"
        fill="rgba(0,180,100,.14)"
        stroke="rgba(0,180,100,.35)"
        strokeWidth=".5"
      />
      <ellipse cx="82" cy="70" rx="22" ry="12" fill="rgba(0,180,100,.2)" />
      <ellipse cx="160" cy="50" rx="26" ry="14" fill="rgba(0,180,100,.25)" />
      <ellipse cx="236" cy="65" rx="18" ry="10" fill="rgba(0,180,100,.18)" />
      <line x1="0" y1="160" x2="320" y2="160" stroke="rgba(0,180,100,.2)" strokeWidth=".5" />
    </svg>
  );
}

export function DistrictGraphic() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 320 188"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <polygon
        points="160,22 268,158 52,158"
        fill="rgba(140,80,220,.08)"
        stroke="rgba(140,80,220,.3)"
        strokeWidth=".8"
      />
      <polygon
        points="160,52 238,148 82,148"
        fill="rgba(140,80,220,.1)"
        stroke="rgba(140,80,220,.2)"
        strokeWidth=".5"
      />
      <circle
        cx="160"
        cy="28"
        r="8"
        fill="rgba(140,80,220,.3)"
        stroke="rgba(140,80,220,.6)"
        strokeWidth=".5"
      />
      <circle cx="52" cy="158" r="6" fill="rgba(140,80,220,.2)" />
      <circle cx="268" cy="158" r="6" fill="rgba(140,80,220,.2)" />
      <line x1="0" y1="160" x2="320" y2="160" stroke="rgba(140,80,220,.15)" strokeWidth=".5" />
    </svg>
  );
}
